import type { QueryKeyFactory } from "app/pages/sales-intelligence/types/queries";

const BASE_KEY = "intent";
const TAXONOMY_DESCRIPTION_QUERY_KEY = "taxonomy-description";

export const intentQueryKeys = {
    taxonomyDescription: () => [BASE_KEY, TAXONOMY_DESCRIPTION_QUERY_KEY] as const,
} as const satisfies QueryKeyFactory;
